<template>
  <div class="radio-input-component-container">
    <div v-if="title" class="radio-group-title">{{ title }}</div>
    <label v-for="({label, value}, index) in options" :key="index" class="vue-radio-container">
      <span v-if="label" :class="labelClass ? labelClass : 'label-wrapper'">{{ label }}</span>
      <input
        :name="name"
        type="radio"
        :value="value"
        :checked="value == selected"
        :disabled="disabled"
        @change="changeHandler(value)"
      />
      <span class="checkmark"></span>
    </label>
    <div v-if="error" class="error-label">
      <img :src="publicUrl + '/input-error-icon.svg'" />
      <span>{{ error }}</span>
    </div>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop */

  export default {
    name: "RadioComponent",
    props: {
      disabled: {type: Boolean, default: false},
      options: {type: Array},
      name: {type: String},
      title: {type: String},
      selected: {type: [String, Number, Boolean]},
      error: {type: String},
      labelClass: {
        type: String,
        default: undefined
      }
    },
    data() {
      return {
        publicUrl: process.env.PUBLIC_URL
      }
    },
    methods: {
      changeHandler(value) {
        this.$emit("on-change-handler", value)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .error-label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 14px;
    span {
      color: #b00020;
      font-weight: 600;
      font-size: 14px;
      padding-left: 6px;
    }
    img {
      height: 24px;
      width: 24px;
    }
  }
  .vue-radio-container {
    display: block;
    position: relative;
    padding-left: 20px;
    margin-bottom: 12px;
    min-height: 20px;
    min-width: 20px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .label-wrapper {
      font-size: 16px;
      font-weight: 400;
      padding-left: 10px;
    }
    .label-semi-bold {
      font-size: 14px;
      font-weight: 600;
      padding-left: 10px;
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: absolute;
      top: 2px;
      left: 0;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 2px solid #b9c1bd;
      &::after {
        content: "";
        position: absolute;
        display: none;
        top: 4px;
        left: 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #1ba26f;
      }
    }
    input:checked ~ .checkmark {
      border-color: #1ba26f;
      &::after {
        display: block;
      }
    }
  }
  .radio-group-title {
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 600;
  }
</style>
